import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HierarchyGetPathParameters } from 'api/actions/hierarchy-get/hierarchy-get-path-parameters';
import { HierarchyGetResponse } from 'api/actions/hierarchy-get/hierarchy-get-response';

type HierarchyGetQueryParameters = Record<string, any>;

/**
 * The path of the HierarchyGet action.
 */
export const hierarchyGetActionPath = new SweetPath<keyof HierarchyGetPathParameters>(
  '/api/hierarchy/get/{hierarchyId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized HierarchyGet actions.
 */
export default function createHierarchyGetAction(axios: AxiosInstance) {
  return function hierarchyGetAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HierarchyGetPathParameters;
    query?: HierarchyGetQueryParameters;
  }) {
    const path = hierarchyGetActionPath.insert(parameters);

    return axios.request<HierarchyGetResponse, HierarchyGetResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
